module.exports = __webpack_public_path__ + "static/media/walletconnect-logo.e1cb8d21.png";